import Seo from '@/components/public/Seo';
import MemberCard from '@/components/public/cards/MemberCard';
import PageHero from '@/components/public/sections/PageHero';
import Container from '@/components/public/ui/Container';
import { useSite } from '@/hooks/useSite';
import type { BodyMemberView } from '@/types';

type Props = { members: BodyMemberView[] };

export default function Assembly({ members }: Props) {
  const mandate = useSite().mandate;
  const [president, ...rest] = members;

  return (
    <>
      <Seo title="Assembleia de Freguesia" description="O órgão deliberativo da freguesia." />
      <PageHero badge="Órgãos autárquicos" title="Assembleia de Freguesia" />
      <Container className="space-y-12 py-12">
        {members.length > 0 ? (
          <p className="text-on-surface-light mx-auto max-w-3xl text-center leading-relaxed">
            Conheça os eleitos que compõem o órgão deliberativo da freguesia
            {mandate ? ` para o mandato ${mandate}` : ''}.
          </p>
        ) : (
          <p className="text-on-surface-light text-center">
            A composição da assembleia estará disponível em breve.
          </p>
        )}

        {president && (
          <section>
            <div className="flex justify-center">
              <MemberCard
                variant="featured"
                initials={president.initials}
                name={president.name ?? ''}
                role={president.role ?? ''}
                photo={president.photoUrl ?? undefined}
                party={president.party ?? undefined}
                mandate={mandate ?? undefined}
              />
            </div>
          </section>
        )}

        {rest.length > 0 && (
          <section>
            <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
              {rest.map((member) => (
                <MemberCard
                  key={member.id}
                  variant="member"
                  initials={member.initials}
                  name={member.name ?? ''}
                  role={member.role ?? ''}
                  photo={member.photoUrl ?? undefined}
                  party={member.party ?? undefined}
                />
              ))}
            </div>
          </section>
        )}
      </Container>
    </>
  );
}
